import { useLocation } from 'react-router-dom';

export const BrandLogo = ({testId,decorative=false,className=''}) => (
  <img
    data-testid={testId}
    className={`official-logo ${className}`}
    src="/brand/mahakali-logo.png"
    alt={decorative?'':'Mahakali Tribunal logo'}
    aria-hidden={decorative?true:undefined}
    width="512"
    height="512"
    decoding="async"
    draggable="false"
  />
);

export const Brand = ({footer=false}) => {
  const {pathname}=useLocation();
  const area=footer?'footer':pathname.startsWith('/editor')?'editor':'header';
  return <span data-testid={`${area}-brand-lockup`} className={`brand ${footer?'brand-footer':''}`}>
    <span className="brand-mark official-brand-mark"><BrandLogo testId={`${area}-brand-logo`} decorative/></span>
    <span data-testid={`${area}-brand-name`}>MAHAKALI TRIBUNAL<small data-testid={`${area}-brand-tagline`}>INTELLIGENCE. JUSTICE. WEALTH.</small></span>
  </span>;
};